import { useDuplicateGoalSection } from 'features/goals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ArrowRight16,
  CopyDuplicateObject,
  PenEdit16,
} from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { Goal } from 'shared/types/goal';

export type EditListProps = {
  goal: Goal;
  sectionId: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  onClose: () => void;
  openGoalSelect: () => void;
};

export const EditList: React.FC<EditListProps> = ({
  goal,
  sectionId,
  inputRef,
  onClose,
  openGoalSelect,
}) => {
  const { t } = useTranslation();
  const duplicateSection = useDuplicateGoalSection();

  const onEditName = (e: React.MouseEvent) => {
    e.preventDefault();
    inputRef?.current?.focus();
    onClose();
  };

  const onDuplicateSection = (e: React.MouseEvent) => {
    e.preventDefault();
    duplicateSection(sectionId, goal);
    onClose();
  };

  const onTransferSection = (e: React.MouseEvent) => {
    e.preventDefault();
    openGoalSelect();
  };

  return (
    <PopupMenuList hasBottomBorder>
      {!!inputRef && (
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onEditName}
            start={<Icon icon={PenEdit16} />}
          >
            {t('context-menus.goal.section.labels.edit')}
          </PopupMenuButton>
        </PopupMenuListItem>
      )}
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={onDuplicateSection}
          start={<Icon icon={CopyDuplicateObject} />}
        >
          {t('context-menus.goal.section.labels.duplicate')}
        </PopupMenuButton>
      </PopupMenuListItem>
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={onTransferSection}
          start={<Icon icon={ArrowRight16} />}
        >
          {t('context-menus.goal.section.labels.move-to-other-goal')}
        </PopupMenuButton>
      </PopupMenuListItem>
    </PopupMenuList>
  );
};
